<template>
  <div>
    <div class="form-container">
      <div class="info-one">
        <div class="form-title margin-b20">评价办法管理</div>
        <div class="base-detail-box">
          <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="110px">
            <el-row style="margin-bottom: 0">
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item label="评价编码：" class="base-detail" style="margin-bottom: 0">
                  {{ baseInfo.evaluationCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评价办法：">{{ baseInfo.evaluateMethodName }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="专业：">{{ baseInfo.specialtyName }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="适用范围：">{{ baseInfo.supplierType }}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <div class="info-one">
        <h3 class="sub-title">评价费用</h3>
        <!-- <div class="handle-btn">
          <eui-btn type="weak" @click="handleEditDialog(slot.scope.row)">
            导入
          </eui-btn>
          <eui-btn type="weak" @click="handleEditDialog(slot.scope.row)">
            下载分项报价模版
          </eui-btn>
        </div> -->
        <div class="table-wrapper">
          <ETableList :table-data="evaluationProductList" :table-label="tableLabel">
            <template #level="{scope}">
              <span>{{ `${scope.row.level}级` }}</span>
            </template>
          </ETableList>
        </div>
      </div>

      <div>
        <div class="base-detail-box">
          <el-form
            :inline="false"
            :model="formData"
            class="demo-form-inline"
            label-width="110px"
            @submit.native.prevent
          >
            <el-row style="margin-bottom: 0; margin-top: 10px;">
              <el-col :span="12">
                <el-form-item label="附录文件：">
                  <FileUpload
                    :limit="1"
                    :url="fileList"
                    tipsMessage="请上传不超过30M的word文件"
                    :fileSize="30"
                    :uploadUrl="uploadEvaluationAttachment"
                    @getFileInfo="getFileInfo"
                    :isOnlyWord="true"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <div class="form-container">
      <div class="form-title margin-b20">业务咨询人</div>
      <div class="table-4">
        <div>
          <div class="table-title-box common-box">
            <div class="first-box">业务咨询人</div>
            <div class="second-box">联系方式</div>
            <div class="third-box">邮箱</div>
            <div class="fourth-box">操作</div>
          </div>
          <div>
            <div v-for="(item, index) in evaluationBusinessConsultList" :key="index">
              <div class="common-box table-content">
                <div class="first-box">
                  <el-input
                    v-model="item.businessConsultName"
                    placeholder="请输入业务咨询人"
                    style="padding: 10px"
                    maxlength="100"
                    show-word-limit
                  ></el-input>
                </div>
                <div class="second-box">
                  <el-input
                    v-model="item.businessConsultTel"
                    placeholder="请输入联系方式"
                    style="padding: 10px"
                  ></el-input>
                </div>
                <div class="third-box">
                  <el-input
                    v-model="item.businessConsultEmail"
                    placeholder="请输入邮箱"
                    style="padding: 10px"
                  ></el-input>
                </div>
                <div class="fourth-box " @click="delStandard(index)">
                  <span
                    class="del-box"
                    :style="{
                      color: evaluationBusinessConsultList.length === 1 ? '#999' : '#0064C8',
                    }"
                  >
                    删除
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="table-bottom">
            <div class="table-add" @click="addStandard">
              <eui-icon class="data-icon" icon="eicon-add" />
              业务咨询人
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-sb">
      <div>
        <eui-btn type="weak" @click="preStep">上一步</eui-btn>
      </div>
      <div>
        <eui-btn type="secondary" style="margin-right: 10px" @click="getDistributorsDetail">
          预览办法
        </eui-btn>
        <eui-btn type="secondary" style="margin-right: 10px" @click="getProducerDetail">
          预览细则
        </eui-btn>
        <eui-btn
          type="weak"
          style="margin-right: 10px"
          :disabled="isSaveStep"
          @click="saveStepFive(0)"
        >
          保 存
        </eui-btn>
        <eui-btn type="primary" :disabled="isSaveStep" @click="saveStepFive(1)">提交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ETableList from '@/modules/projectA/components/common/e-table-list';
import FileUpload from './fileUpload.vue';
import Api from '@/modules/projectA/api/ESorganization/index';
export default {
  props: {
    // 103 没第5步了
    supplierType: {
      type: String,
      default: '',
    },
    evaluationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      formData: {},

      /* businessObj: {
        evaluationBusinessConsultList: []
      }, */
      rules: {},
      tableData: [],
      tableLabel: [
        {
          label: '检测等级',
          align: 'center',
          minWidth: 140,
          slot: 'level',
        },
        {
          label: '产品名称',
          param: 'productName',
          align: 'center',
          minWidth: 280,
        },
        {
          label: '检测费',
          param: 'amount',
          align: 'center',
          minWidth: 140,
        },
      ],
      evaluationProductList: [],
      evaluationAttachment: {},
      evaluationBusinessConsultList: [
        {
          businessConsultEmail: '',
          businessConsultName: '',
          businessConsultTel: '',
        },
      ],
      baseInfo: {},
      stepFiveObj: {
        tempSaveOrConfirmNext: 1,
        currentStep: 5,
        evaluationCode: 'EQE190102001',
        evaluationId: 0,
        evaluationAttachment: {},
        evaluationBusinessConsultList: [
          {
            businessConsultEmail: '',
            businessConsultName: '',
            businessConsultTel: '',
          },
        ],
      },
      uploadEvaluationAttachment: '',
      fileList: [],
      isSaveStep: false,
    };
  },
  components: { ETableList, FileUpload },
  computed: {},
  mounted() {
    this.getDetailInfo();
    this.uploadEvaluationAttachment = Api.uploadEvaluationAttachment();
    console.log(this.uploadEvaluationAttachment, 'this.uploadEvaluationAttachment');
  },
  methods: {
    // 预览细则
    async getProducerDetail() {
      const result = await Api.producerDetail({
        evaluationId: this.evaluationId,
      });
      console.log(result, 'this.evaluationId');
    },
    // 预判评标办法
    async getDistributorsDetail() {
      const result = await Api.producer({
        evaluationId: this.evaluationId,
      });
      console.log(result, 'this.producer');
    },
    async getDetailInfo() {
      const result = await Api.stepDetail({
        currentStep: 5,
        evaluationId: this.evaluationId,
      });
      // detailInfo
      console.log(result);
      if (result.code === '200') {
        const {
          evaluationProductList = [],
          evaluationBusinessConsultList = [],
          evaluationAttachment = {},
        } = result.data;
        this.baseInfo = { ...result.data };
        const isEvaluationProductList = evaluationProductList[0]?.amount;
        if (evaluationProductList.length !== 0 && isEvaluationProductList) {
          this.evaluationProductList = [...evaluationProductList];
        } else {
          this.evaluationProductList = [];
        }
        if (evaluationBusinessConsultList.length !== 0) {
          this.evaluationBusinessConsultList = [...evaluationBusinessConsultList];
        }
        // 回显文件
        if (evaluationAttachment.evaluateMethodAttachPath) {
          const {
            evaluateMethodAttachName = '',
            evaluateMethodAttachPath = '',
          } = evaluationAttachment;
          const item = {
            fileName: evaluateMethodAttachName,
            url: evaluateMethodAttachPath,
          };
          this.fileList = [item];
        }
      }
    },

    addStandard() {
      const item = {
        businessConsultEmail: '',
        businessConsultName: '',
        businessConsultTel: '',
      };
      this.evaluationBusinessConsultList.push(item);
      console.log(this.evaluationBusinessConsultList);
    },
    delStandard(index) {
      if (this.evaluationBusinessConsultList.length === 1) {
        return false;
      }
      this.evaluationBusinessConsultList.splice(index, 1);
    },

    getFileInfo(info) {
      const [item = {}] = info;
      /* evaluationAttachment: {
        evaluateMethodAttachName: '评价办法附录文件名称',
        evaluateMethodAttachPath: '评价办法附录文件url',
      }, */
      console.log(info, item);
      this.evaluationAttachment.evaluateMethodAttachName = item.fileName || '';
      this.evaluationAttachment.evaluateMethodAttachPath = item.fileUrl || '';
    },
    /* function checkEmail(email) {
      const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      return emailReg.test(email);
    } */
    /* 
      function checkPhone(tel) {
      const mobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      return mobile.test(tel)
    }
    */
    async saveStepFive(tempSaveOrConfirmNext) {
      if (tempSaveOrConfirmNext === 1) {
        const isMobile = this.evaluationBusinessConsultList.some(el => {
          const mobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          return mobile.test(el.businessConsultTel);
        });
        if (!isMobile) {
          return this.$message.warning('请输入正确联系方式');
        }
        const isEmail = this.evaluationBusinessConsultList.some(el => {
          const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
          return emailReg.test(el.businessConsultEmail);
        });
        if (!isEmail) {
          return this.$message.warning('请输入正确的邮箱');
        }
      }

      this.stepFiveObj = {
        ...this.baseInfo,
        evaluationAttachment: this.evaluationAttachment,
        evaluationBusinessConsultList: this.evaluationBusinessConsultList,
        currentStep: 5,
        tempSaveOrConfirmNext,
      };
      try {
        this.isSaveStep = true;
        const result = await Api.tempSaveOrConfirmNext(this.stepFiveObj);
        if (result.code === '200') {
          this.$message.success('操作成功');
          if (tempSaveOrConfirmNext === 1) {
            this.$router.push({
              path: '/ES/ESorganization',
            });
          }
        }
      } finally {
        this.isSaveStep = false;
      }
    },
    preStep() {
      this.$emit('getStep', 4);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  ::v-deep .el-input__suffix {
    right: 15px;
    font-weight: normal;
  }
  .info-one {
    border-bottom: 1px dashed #c5c5c5;
    padding-bottom: 20px;
    .base-detail-box {
      margin-bottom: -10px;
      ::v-deep .el-form-item__label {
        color: #666;
      }
      ::v-deep .el-form-item--small.el-form-item {
        margin-bottom: 0;
      }
      ::v-deep .el-form-item--small.el-form-item {
        margin-bottom: 0;
      }
    }
  }

  .sub-title {
    margin: 20px 0;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
  }
  .table-wrapper {
    margin-top: 10px;
  }
  .table-4 {
    .common-box {
      width: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      border: 1px solid #dcdcdc;
      border-bottom: none;
      font-size: 12px;
      color: #333;
      font-weight: bold;
      .first-box {
        flex: 1;
        height: 100%;
        //height: calc(100% - 1px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .second-box {
        flex: 2;
        height: 100%;
        //height: calc(100% - 1px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .third-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .fourth-box {
        width: 80px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .table-title-box {
      height: 40px;
      background-color: #f5f5f5;
    }
    .table-content {
      height: 50px;
      .del-box {
        color: #0064c8;
        cursor: pointer;
        font-size: 14px;
      }
    }
    .table-bottom {
      height: 60px;
      padding: 10px;
      background-color: #f5f5f5;
      border: 1px solid #dcdcdc;
      .data-icon {
        width: 10px;
        height: 10px;
        margin-right: 10px;
      }
      .table-add {
        cursor: pointer;
        background-color: #fff;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
